import React from 'react'
import {createRoot, Root} from 'react-dom/client'
import {OnboardingNotification, NotificationType} from '../components/OnboardingNotification'

let notificationContainer: HTMLElement | null = null
let notificationRoot: Root | null = null
const DEFAULT_NOTIFICATION_DURATION = 20000

const createNotificationContainer = () => {
    if (!notificationContainer) {
        notificationContainer = document.createElement('div')
        notificationContainer.style.position = 'fixed'
        notificationContainer.style.top = '20px'
        notificationContainer.style.right = '20px'
        notificationContainer.style.zIndex = '9999'
        notificationContainer.style.maxWidth = '400px'
        document.body.appendChild(notificationContainer)
        notificationRoot = createRoot(notificationContainer)
    }
    return {container: notificationContainer, root: notificationRoot}
}

const showNotification = (
    type: NotificationType,
    message: string,
    duration = DEFAULT_NOTIFICATION_DURATION
) => {
    const {root} = createNotificationContainer()

    const handleClose = () => {
        root.render(null)
        setTimeout(() => {
            if (notificationContainer && document.body.contains(notificationContainer)) {
                document.body.removeChild(notificationContainer)
                notificationContainer = null
                notificationRoot = null
            }
        }, 100)
    }

    root.render(
        <OnboardingNotification
            type={type}
            message={message}
            onClose={handleClose}
            visible={true}
        />
    )

    if (duration > 0) {
        setTimeout(handleClose, duration)
    }
}

export const onboardingMessage = {
    success: (message: string, duration?: number) => showNotification('success', message, duration),
    error: (message: string, duration?: number) => showNotification('error', message, duration),
    warning: (message: string, duration?: number) => showNotification('warning', message, duration),
    info: (message: string, duration?: number) => showNotification('info', message, duration)
}
